/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { FaCheckCircle, FaFilePdf, FaSearch, FaSyncAlt } from 'react-icons/fa';
import ModalAnalise from '../../../components/locasmartcheck/ModalAnalise';
import ModalVisualizarVistoria from '../../../components/locasmartcheck/ModalVisualizarVistoria';
import ModalSincronizacao from '../../../components/locasmartcheck/ModalSincronizacao';
import logoLocaSmartCheck from '../../../assets/logo-locasmartcheck.png';
import { confirm } from '../../../components/confirm';
import { toast } from 'react-toastify';
import api from '../../../services/api';
import { AcaoGrid, Campo, CheckInspection, CheckInspectionTemplate, CheckInspectionTemplateItem, Opcao } from '../../../services/tipos';
import { TipoFormulario } from '../../../services/constantes';
import { obterNomeUsuario } from '../../../services/seguranca';
import { useAppSelector } from '../../../store/hooks';
import Listagem from '../../../components/listagem';
import ModalForm from '../../../components/modal-form';
import { FaCheckToSlot } from 'react-icons/fa6';

function formatDate(dateStr: string | null | undefined): string {
    if (!dateStr) return '-';
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return '-';
    return date.toLocaleDateString('pt-BR', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit',
    });
}

function getStatusLabel(status: string): string {
    switch (status) {
        case 'Completed': return 'Concluída';
        case 'InProgress': return 'Em Andamento';
        case 'AwaitingAnalysis': return 'Aguardando Análise';
        case 'Canceled': return 'Cancelada';
        case 'Pending': return 'Pendente';
        case 'Scheduled': return 'Agendada';
        default: return status;
    }
}

function getStatusColor(status: string): string {
    switch (status) {
        case 'Completed': return '#4CAF50';
        case 'InProgress': return '#2196F3';
        case 'AwaitingAnalysis': return '#FFC107';
        case 'Canceled': return '#f44336';
        default: return '#9e9e9e';
    }
}

const statusItemOpcoes: Opcao[] = [
    { label: 'OK', valor: 'Ok' },
    { label: 'Avaria', valor: 'Damage' },
    { label: 'N/A', valor: 'NotApplicable' },
];

interface VistoriaIntegradaProps {
    onAbrirOnboarding?: () => void;
}

function VistoriaIntegrada({ onAbrirOnboarding }: VistoriaIntegradaProps) {
    const token = useAppSelector(state => state.token);
    const nomeUsuario = obterNomeUsuario(token);
    const [inspections, setInspections] = useState<CheckInspection[]>([]);
    const [carregando, setCarregando] = useState(false);
    const [isSubmiting, setIsSubmiting] = useState(false);

    const [exibirModal, setExibirModal] = useState(false);
    const [modo, setModo] = useState<TipoFormulario>(TipoFormulario.tpNenhum);
    const [inspecaoSelecionada, setInspecaoSelecionada] = useState<any>({});

    const [modalSincOpen, setModalSincOpen] = useState(false);

    // Análise
    const [analiseAberta, setAnaliseAberta] = useState(false);
    const [inspecaoAnalise, setInspecaoAnalise] = useState<CheckInspection | null>(null);
    // Vistoria aberta no modal com as fotos dos itens (botão "Imagens").
    const [vistoriaComFotos, setVistoriaComFotos] = useState<CheckInspection | null>(null);

    // Selects para cadastro
    const [templates, setTemplates] = useState<CheckInspectionTemplate[]>([]);
    const [modelosOp, setModelosOp] = useState<Opcao[]>([]);
    const [veiculosOp, setVeiculosOp] = useState<Opcao[]>([]);
    const [motoristasOp, setMotoristasOp] = useState<Opcao[]>([]);
    const [carregandoSelects, setCarregandoSelects] = useState(false);
    const [templateItems, setTemplateItems] = useState<CheckInspectionTemplateItem[]>([]);

    const fetchInspections = async () => {
        setCarregando(true);
        try {
            const response = await api.get('/LocaSmartCheck/Vistorias', {
                params: { page: 1, pageSize: 100 },
            });

            if (Array.isArray(response.data)) {
                setInspections(response.data);
            } else if (response.data?.items) {
                setInspections(response.data.items);
            } else {
                setInspections([]);
            }
        } catch {
            toast.error('Erro ao carregar vistorias do LocaSmartCheck');
        } finally {
            setCarregando(false);
        }
    };

    const fetchSelects = async () => {
        setCarregandoSelects(true);
        try {
            const [templatesRes, veiculosRes, motoristasRes] = await Promise.all([
                api.get('/LocaSmartCheck/ModelosVistoria'),
                api.get('/LocaSmartCheck/Veiculos'),
                api.get('/LocaSmartCheck/Motoristas'),
            ]);

            if (Array.isArray(templatesRes.data)) {
                setTemplates(templatesRes.data);
                setModelosOp(templatesRes.data.map((t: CheckInspectionTemplate) => ({
                    label: t.name,
                    valor: t.id,
                })));
            }

            if (Array.isArray(veiculosRes.data)) {
                setVeiculosOp(veiculosRes.data.map((v: any) => ({
                    label: `${v.plate} - ${v.brand} ${v.model}`,
                    valor: v.id,
                })));
            }

            if (Array.isArray(motoristasRes.data)) {
                setMotoristasOp(motoristasRes.data.map((m: any) => ({
                    label: m.name,
                    valor: m.id,
                })));
            }
        } catch {
            toast.error('Erro ao carregar dados para o formulário');
        } finally {
            setCarregandoSelects(false);
        }
    };

    useEffect(() => {
        fetchInspections();
    }, []);

    const handleTemplateSelecionado = (templateId: any) => {
        if (!templateId) {
            setTemplateItems([]);
            return;
        }
        const template = templates.find(t => t.id === templateId);
        if (template?.items) {
            const sorted = [...template.items].sort((a, b) => a.order - b.order);
            setTemplateItems(sorted);
        } else {
            setTemplateItems([]);
        }
    };

    // Campos para cadastro - gerados dinamicamente baseado no template selecionado
    const getCamposCadastro = (): Campo[] => {
        const base: Campo[] = [
            {
                label: 'Modelo de Vistoria', nome: 'templateId', tipo: 'select', largura: 12, coluna: 1, linha: 1, required: true,
                opcoes: modelosOp, carregando: carregandoSelects,
                onCampoDigitar: handleTemplateSelecionado,
            },
            { label: 'Veículo', nome: 'vehicleId', tipo: 'select', largura: 6, coluna: 1, linha: 2, required: true, opcoes: veiculosOp, carregando: carregandoSelects },
            { label: 'Motorista', nome: 'driverId', tipo: 'select', largura: 6, coluna: 1, linha: 2, required: false, opcoes: motoristasOp, carregando: carregandoSelects },
            { label: 'Hodômetro', nome: 'mileage', tipo: 'number', largura: 6, coluna: 1, linha: 3, required: false },
            { label: 'Observação', nome: 'notes', tipo: 'memo', largura: 12, coluna: 1, linha: 4, required: false },
        ];

        // Adicionar campos para cada item do template
        let linhaAtual = 5;
        templateItems.forEach((item: CheckInspectionTemplateItem) => {
            base.push({
                label: item.name,
                nome: `item_${item.id}`,
                tipo: 'select',
                largura: 6,
                coluna: 1,
                linha: linhaAtual,
                required: true,
                opcoes: statusItemOpcoes,
                subLabel: item.description || undefined,
            });
            base.push({
                label: `Obs. ${item.name}`,
                nome: `item_obs_${item.id}`,
                tipo: 'text',
                largura: 6,
                coluna: 1,
                linha: linhaAtual,
                required: false,
            });
            linhaAtual++;

            base.push({
                label: `Foto - ${item.name}`,
                nome: `item_foto_${item.id}`,
                tipo: 'image',
                largura: 12,
                coluna: 1,
                linha: linhaAtual,
                required: false,
            });
            linhaAtual++;
        });

        return base;
    };

    const getPagesCadastro = () => {
        const pages = [
            { titulo: 'Informações', campos: ['templateId', 'vehicleId', 'driverId', 'mileage', 'notes'] },
        ];

        if (templateItems.length > 0) {
            const camposChecklist: string[] = [];
            templateItems.forEach((item: CheckInspectionTemplateItem) => {
                camposChecklist.push(`item_${item.id}`);
                camposChecklist.push(`item_obs_${item.id}`);
                camposChecklist.push(`item_foto_${item.id}`);
            });
            pages.push({ titulo: 'Checklist', campos: camposChecklist });
        }

        return pages;
    };

    const colunas = [
        { field: 'templateName', headerName: 'Modelo', flex: 1, sortable: false, filterable: false },
        {
            field: 'veiculo', headerName: 'Veículo', flex: 1.5, sortable: false, filterable: false,
            renderCell: (params: any) => {
                const row = params.row as CheckInspection;
                return <Typography variant="body2">{row.vehiclePlate} - {row.vehicleModel}</Typography>;
            },
        },
        {
            field: 'driverName', headerName: 'Motorista', flex: 1, sortable: false, filterable: false,
            renderCell: (params: any) => <Typography variant="body2">{params.value || '-'}</Typography>,
        },
        { field: 'mileage', headerName: 'Hodômetro', flex: 0.7, sortable: false, filterable: false },
        {
            field: 'data', headerName: 'Data', flex: 1, sortable: false, filterable: false,
            renderCell: (params: any) => {
                const row = params.row as CheckInspection;
                return <Typography variant="body2">{formatDate(row.completedAt || row.createdAt)}</Typography>;
            },
        },
        {
            field: 'status', headerName: 'Status', flex: 1, sortable: false, filterable: false,
            renderCell: (params: any) => (
                <Chip label={getStatusLabel(params.value)} size="small"
                    sx={{ backgroundColor: getStatusColor(params.value), color: 'white', fontWeight: 'bold' }} />
            ),
        },
    ];

    // Campos para visualização
    const camposVisualizacao: Campo[] = [
        { label: 'Modelo', nome: 'templateName', tipo: 'text', largura: 12, coluna: 1, linha: 1, required: false, apenasLeitura: true },
        { label: 'Veículo', nome: '_veiculo', tipo: 'text', largura: 6, coluna: 1, linha: 2, required: false, apenasLeitura: true },
        { label: 'Motorista', nome: 'driverName', tipo: 'text', largura: 6, coluna: 1, linha: 2, required: false, apenasLeitura: true },
        { label: 'Hodômetro', nome: 'mileage', tipo: 'number', largura: 4, coluna: 1, linha: 3, required: false, apenasLeitura: true },
        { label: 'Data', nome: '_data', tipo: 'text', largura: 4, coluna: 1, linha: 3, required: false, apenasLeitura: true },
        { label: 'Status', nome: '_status', tipo: 'text', largura: 4, coluna: 1, linha: 3, required: false, apenasLeitura: true },
        { label: 'Vistoriador', nome: 'inspectorName', tipo: 'text', largura: 6, coluna: 1, linha: 4, required: false, apenasLeitura: true },
        {
            label: 'Localização', nome: '_localizacao', tipo: 'custom', largura: 6, coluna: 1, linha: 4, required: false,
            component: ({ value }: any) => {
                if (!value) return <Typography variant="body2" color="text.secondary">Sem localização</Typography>;
                const coords = value.split(',').map((s: string) => s.trim());
                const link = `https://www.google.com/maps?q=${coords[0]},${coords[1]}`;
                return (
                    <Typography
                        variant="body2"
                        component="a"
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{ color: '#1976d2', textDecoration: 'underline', cursor: 'pointer' }}
                    >
                        {value}
                    </Typography>
                );
            },
        },
        { label: 'Observação', nome: 'notes', tipo: 'memo', largura: 12, coluna: 1, linha: 5, required: false, apenasLeitura: true },
        {
            label: 'Itens da Vistoria', nome: '_itens', tipo: 'custom', largura: 12, coluna: 1, linha: 6, required: false,
            component: ({ value }) => {
                if (!value || !Array.isArray(value)) return <Typography variant="body2" color="text.secondary">Nenhum item registrado</Typography>;
                return (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        {value.map((item: any, idx: number) => (
                            <Box key={idx} sx={{
                                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                p: 1.5, borderRadius: 1, border: '1px solid #e0e0e0', backgroundColor: '#fafafa',
                            }}>
                                <Box>
                                    <Typography variant="body2" fontWeight={500}>{item.templateItemName}</Typography>
                                    {item.notes && <Typography variant="caption" color="text.secondary">{item.notes}</Typography>}
                                </Box>
                                <Chip
                                    label={item.status === 'Ok' ? 'OK' : item.status === 'Damage' ? 'Avaria' : 'N/A'}
                                    size="small"
                                    sx={{
                                        backgroundColor: item.status === 'Ok' ? '#4CAF50' : item.status === 'Damage' ? '#f44336' : '#9e9e9e',
                                        color: 'white', fontWeight: 'bold',
                                    }}
                                />
                            </Box>
                        ))}
                    </Box>
                );
            },
        },
    ];

    const pagesVisualizacao = [
        { titulo: 'Informações', campos: ['templateName', '_veiculo', 'driverName', 'mileage', '_data', '_status', 'inspectorName', '_localizacao', 'notes'] },
        { titulo: 'Itens da Vistoria', campos: ['_itens'] },
    ];

    const handleCriar = () => {
        setTemplateItems([]);
        fetchSelects();
        setInspecaoSelecionada({});
        setModo(TipoFormulario.tpCadastro);
        setExibirModal(true);
    };

    const parseGpsFromNotes = (notes: string | null | undefined): { lat: string; lng: string } | null => {
        if (!notes) return null;
        const match = notes.match(/GPS(?:\s*Final)?:\s*([-\d.]+)\s*,\s*([-\d.]+)/);
        if (!match) return null;
        return { lat: match[1], lng: match[2] };
    };

    const reverseGeocode = async (lat: string, lng: string): Promise<string> => {
        try {
            const resp = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json&accept-language=pt-BR`);
            const data = await resp.json();
            if (data?.address) {
                const a = data.address;
                const parts = [a.road, a.suburb || a.neighbourhood, a.city || a.town || a.village, a.state].filter(Boolean);
                return parts.join(', ') || data.display_name || `${lat}, ${lng}`;
            }
            return `${lat}, ${lng}`;
        } catch {
            return `${lat}, ${lng}`;
        }
    };

    const handleVisualizar = async (entidade: any) => {
        const row = entidade as CheckInspection;
        const gps = parseGpsFromNotes(row.notes);
        const obsLimpa = row.notes?.replace(/GPS(?:\s*Final)?:\s*[-\d.]+\s*,\s*[-\d.]+\s*(\(acc:.*?\))?/g, '').trim() || '';

        let localizacao = '';
        let linkMapa = '';
        if (gps) {
            linkMapa = `https://www.google.com/maps?q=${gps.lat},${gps.lng}`;
            localizacao = await reverseGeocode(gps.lat, gps.lng);
        }

        setInspecaoSelecionada({
            ...row,
            _veiculo: `${row.vehiclePlate} - ${row.vehicleModel}`,
            _data: formatDate(row.completedAt || row.createdAt),
            _status: getStatusLabel(row.status),
            _itens: row.items,
            _localizacao: localizacao,
            _linkMapa: linkMapa,
            notes: obsLimpa || null,
        });
        setModo(TipoFormulario.tpVisualizacao);
        setExibirModal(true);
    };

    const handleExclusao = async (entidade: any) => {
        const row = entidade as CheckInspection;
        const confirmou = await confirm(`Deseja realmente excluir a vistoria "${row.templateName}" do veículo ${row.vehiclePlate}?`);
        if (!confirmou) return;

        try {
            await api.delete(`/LocaSmartCheck/Vistorias/${row.id}`);
            toast.success('Vistoria excluída com sucesso!');
            fetchInspections();
        } catch (error: any) {
            const msg = error.response?.data?.Mensagem || error.response?.data?.errorMessage || 'Erro ao excluir vistoria';
            toast.error(msg);
        }
    };

    const handleFecharModal = () => {
        setExibirModal(false);
        setModo(TipoFormulario.tpNenhum);
        setInspecaoSelecionada({});
        setTemplateItems([]);
    };

    const fileToBase64 = (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const result = reader.result as string;
                // Remove o prefixo "data:image/...;base64,"
                const base64 = result.split(',')[1] || result;
                resolve(base64);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };

    const handleSalvar = async (entidade: any) => {
        setIsSubmiting(true);
        try {
            // Montar itens a partir dos campos item_*
            const items = [];
            for (const ti of templateItems) {
                const photos: any[] = [];

                const fotoValue = entidade[`item_foto_${ti.id}`];
                if (fotoValue && fotoValue instanceof File) {
                    const base64 = await fileToBase64(fotoValue);
                    photos.push({
                        fieldName: ti.name,
                        fileBase64: base64,
                        contentType: fotoValue.type || 'image/jpeg',
                        fileName: fotoValue.name,
                    });
                }

                items.push({
                    inspectionTemplateItemId: ti.id,
                    status: entidade[`item_${ti.id}`] || 'NotApplicable',
                    notes: entidade[`item_obs_${ti.id}`] || '',
                    photos,
                });
            }

            await api.post('/LocaSmartCheck/Vistorias', {
                templateId: entidade.templateId,
                vehicleId: entidade.vehicleId,
                driverId: entidade.driverId || null,
                mileage: entidade.mileage ? Number(entidade.mileage) : 0,
                notes: entidade.notes || '',
                items,
            });
            toast.success('Vistoria registrada com sucesso!');
            handleFecharModal();
            fetchInspections();
        } catch (error: any) {
            const msg = error.response?.data?.Mensagem || error.response?.data?.errorMessage || 'Erro ao criar vistoria';
            toast.error(msg);
        } finally {
            setIsSubmiting(false);
        }
    };

    const handleRelatorio = async (entidade: any) => {
        const row = entidade as CheckInspection;
        try {
            const response = await api.get(`/LocaSmartCheck/Relatorio/${row.id}`, { responseType: 'blob' });
            const blobUrl = URL.createObjectURL(response.data);
            window.open(blobUrl, '_blank');
            setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
        } catch (error) {
            toast.error('Erro ao abrir relatório');
        }
    };

    const handleAnalisar = (entidade: any) => {
        const row = entidade as CheckInspection;
        setInspecaoAnalise(row);
        setAnaliseAberta(true);
    };

    const acoesExtrasGrid: AcaoGrid[] = [
        {
            Texto: 'Analisar',
            OnClick: handleAnalisar,
            Icone: FaCheckToSlot as any,
            Cor: '#ff9800',
            Condicao: (entidade: any) => entidade.status !== 'Completed' && entidade.status !== 'Canceled',
        },
        {
            Texto: 'Relatório',
            OnClick: handleRelatorio,
            Icone: FaFilePdf as any,
            Cor: '#d32f2f',
        },
    ];

    const tratarErro = () => {
        setCarregando(false);
        setIsSubmiting(false);
        toast.error('Erro na operação');
    };

    return (
        <>
            <Listagem
                colunas={colunas}
                linhas={inspections}
                nomeEntidade="Vistoria"
                nomePropriedade="templateName"
                carregando={carregando}
                IconeEntidade={FaCheckCircle}
                handleCriar={handleCriar}
                handleExclusao={handleExclusao}
                handleVisualizacao={handleVisualizar}
                handleSelecionarEntidade={setInspecaoSelecionada}
                acoesExtras={acoesExtrasGrid}
                headerExtra={(
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <button
                            onClick={() => setModalSincOpen(true)}
                            style={{
                                display: 'flex', alignItems: 'center', gap: 6,
                                padding: '4px 12px', borderRadius: 20,
                                border: '1.5px solid #2e7d32', backgroundColor: '#e8f5e9',
                                cursor: 'pointer', fontSize: 13, fontWeight: 600,
                                color: '#1b5e20', transition: 'all 0.2s',
                            }}
                            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#c8e6c9'; }}
                            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#e8f5e9'; }}
                        >
                            <FaSyncAlt size={14} />
                            Sincronizar
                        </button>
                        {onAbrirOnboarding && (
                            <button
                                onClick={onAbrirOnboarding}
                                style={{
                                    display: 'flex', alignItems: 'center', gap: 6,
                                    padding: '4px 12px', borderRadius: 20,
                                    border: '1.5px solid #1976d2', backgroundColor: '#e3f2fd',
                                    cursor: 'pointer', fontSize: 13, fontWeight: 600,
                                    color: '#1565c0', transition: 'all 0.2s',
                                }}
                                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#bbdefb'; }}
                                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#e3f2fd'; }}
                            >
                                <img src={logoLocaSmartCheck} alt="" style={{ width: 18, height: 18, borderRadius: 4 }} />
                                Como usar o LocaSmartCheck?
                            </button>
                        )}
                    </Box>
                )}
            />

            <ModalAnalise
                open={analiseAberta}
                onClose={() => setAnaliseAberta(false)}
                inspection={inspecaoAnalise}
                onSuccess={fetchInspections}
                nomeUsuario={nomeUsuario}
            />

            <ModalVisualizarVistoria
                open={!!vistoriaComFotos}
                onClose={() => setVistoriaComFotos(null)}
                inspection={vistoriaComFotos}
            />

            <ModalSincronizacao
                open={modalSincOpen}
                onClose={() => setModalSincOpen(false)}
            />

            <ModalForm
                planoPremium={true}
                modo={modo}
                tamanho="lg"
                titulo={modo === TipoFormulario.tpCadastro ? 'Nova Vistoria' : 'Detalhes da Vistoria'}
                campos={modo === TipoFormulario.tpCadastro ? getCamposCadastro() : camposVisualizacao}
                pages={modo === TipoFormulario.tpCadastro ? getPagesCadastro() : pagesVisualizacao}
                show={exibirModal}
                carregando={carregando}
                isSaving={isSubmiting}
                tituloBotaoOk={modo === TipoFormulario.tpCadastro ? 'Registrar' : undefined}
                onSave={modo === TipoFormulario.tpCadastro ? handleSalvar : undefined}
                onHide={handleFecharModal}
                onCancel={handleFecharModal}
                entidadeSelecionada={inspecaoSelecionada}
                botoesExtras={modo === TipoFormulario.tpVisualizacao ? [
                    {
                        titulo: 'Relatório',
                        cor: '#d32f2f',
                        onClick: async (entidade: any) => {
                            if (!entidade?.id) return;
                            try {
                                const response = await api.get(`/LocaSmartCheck/Relatorio/${entidade.id}`, { responseType: 'blob' });
                                const blobUrl = URL.createObjectURL(response.data);
                                window.open(blobUrl, '_blank');
                                setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
                            } catch (error) {
                                toast.error('Erro ao abrir relatório');
                            }
                        },
                    },
                    {
                        titulo: 'Imagens',
                        cor: '#1976d2',
                        // Antes reabria o próprio modal de detalhes, que não tem fotos (DL-161).
                        onClick: (entidade: any) => {
                            if (!entidade?.id) return;
                            setVistoriaComFotos(inspections.find(i => i.id === entidade.id) ?? (entidade as CheckInspection));
                        },
                    },
                ] : undefined}
                apiConfig={{
                    endpoint: '',
                    requisicaoBemSucedida: () => { handleFecharModal(); fetchInspections(); },
                    tratarErro: tratarErro,
                    idTenentCampo: 'idEmpresa',
                }}
            />
        </>
    );
}

export default VistoriaIntegrada;
